import { render, staticRenderFns } from "./ChecklistCreateUpdateList.vue?vue&type=template&id=54dd0cf0&scoped=true&"
import script from "./ChecklistCreateUpdateList.vue?vue&type=script&lang=js&"
export * from "./ChecklistCreateUpdateList.vue?vue&type=script&lang=js&"
import style0 from "./ChecklistCreateUpdateList.vue?vue&type=style&index=0&id=54dd0cf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dd0cf0",
  null
  
)

export default component.exports